import React, { createContext, useContext, useState, useEffect } from 'react';
import authService from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is authenticated on app load
    const checkAuth = () => {
      const authenticated = authService.isAuthenticated();
      setIsAuthenticated(authenticated);
      setIsLoading(false);
    };

    checkAuth();

    // Automatyczne sprawdzanie ważności tokenu co 5 minut
    const tokenCheckInterval = setInterval(async () => {
      const token = authService.getAccessToken();
      if (token && authService.isTokenExpiringSoon(token)) {
        try {
          console.log('Automatyczne odświeżanie tokenu...');
          await authService.refreshAccessToken();
          console.log('Token odświeżony pomyślnie');
        } catch (error) {
          console.error('Błąd podczas automatycznego odświeżania tokenu:', error);
          // Jeśli refresh się nie udał, wyloguj użytkownika
          await logout();
        }
      }
    }, 5 * 60 * 1000); // 5 minut

    return () => {
      clearInterval(tokenCheckInterval);
    };
  }, []);

  const login = async (username, password) => {
    try {
      await authService.login(username, password);
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    await authService.logout();
    setIsAuthenticated(false);
  };

  const value = {
    isAuthenticated,
    isLoading,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 